class VehicleModel{
    vehicleId?: number;
    code:string;
    vehicleNumber?: string;
    driverName?: string;
    licenceNumber?: string;
    driverMobile?:string;
    capacityInKg?: number;
    vehicleTransportId:number;
    vehicleTransportName:string;
    vehicleTypeId?: number;
    vehicleTypeName?: string;
    fcDocumentPath?: string;
    fcExpiryDate?:string;
    insuranceDocumentPath?: string;
    insuranceExpiryDate:string;
    contractStartFrom?: string;
    contractEndsOn?: string;
    trayCapacity?:number;
    isActive?:boolean;
    
}
export default VehicleModel;